import { inject } from "@angular/core";
import { NavigationService } from "app/core/navigation/navigation.service";
import { forkJoin } from "rxjs";
// import { SearchV2Service } from "./layout/common/search/search-v2.service";
import { AuthDavesaV2Service } from "./core/auth-davesa/auth-davesa-v2.service";
import { EntitiesDataV2Service } from "./modules/davesa/administration/entities-data/entity-data-v2.service";
import { NotificationsV2Service } from "./layout/common/notifications/notifications-v2.service";
import { ShortcutsService } from "./layout/common/shortcuts/shortcuts.service";


export const organizationsResolver = () => {
  const navigationService = inject(NavigationService);

  // Fork join multiple API endpoint calls to wait all of them to finish
  return forkJoin([navigationService.get()]);
};

export const initialDataResolver = () => {
  const _authDavesaV2Service = inject(AuthDavesaV2Service);
  const _navigationService = inject(NavigationService);
  const _entitiesDataV2Service = inject(EntitiesDataV2Service);
  // const _searchV2Service = inject(SearchV2Service);
  // const _clinicNowV2Service = inject(ClinicNowV2Service);
  // const _messagesService = inject(MessagesService);
  const _notificationsV2Service = inject(NotificationsV2Service);
  // const shortcutsService = inject(ShortcutsService);
  const params = {
    offset: 0,
    limit: 0,
    sort_field: "",
    query: "",
  };
  const notificationsParams = {
    offset: 0,
    limit: 10,
    sort_field: 'created_at',
    sort_direction: 'D',
    query: '',
    read_type: 0,
    category_id: 0,
  };
  const notificationCategoriesParams = {
    offset: 0,
    limit: 0,
    sort_field: 'created_at',
    sort_direction: 'D',
    query: '',
  };
  // Fork join multiple API endpoint calls to wait all of them to finish
  return forkJoin([
    _authDavesaV2Service.initiate(),
    _navigationService.get(),
    _entitiesDataV2Service.getAllEntitiesData(),
    // _entitiesDataV2Service.getAllByEntity(),
    _notificationsV2Service.getAllNotifications(notificationsParams)
    // _searchV2Service.getAllSearch(),
    // _clinicNowV2Service.getAllClinicVisits(),
    // messagesService.getAll(),
    // clinicNowService.getAll(),
    // shortcutsService.getAll(),
  ]);
};
